type NullishDate = Temporal.PlainDate | undefined;
type PlainDateCalendarProps =
	| {
		mode: "single";
		value: NullishDate;
		setValue: Setter<NullishDate>;
	}
	| {
		mode: "range";
		value: Readonly<[NullishDate, NullishDate]>;
		setValue: Setter<Readonly<[NullishDate, NullishDate]>>;
	};
import { Calendar as Calendar2, type CalendarProps as CalendarProps2 } from "./custom_calendar";
export function PlainDateCalendar(props: PlainDateCalendarProps & CalendarProps2) {
	const { value, setValue, mode } = props;

	if (mode === "single") {
		return <Calendar2
			{...props}
			selectedDate={value}
			setSelectedDate={setValue}
		/>;
	} else {
		return <Calendar2
			{...props}
			selectedRange={value}
			setSelectedRange={setValue}
		/>;
	}
}